<template>
    <div class="order-consumption-page">
        <!-- 页面头部 -->
        <div class="order-consumption-page__header">
            <div class="order-consumption-page__header-left">
                <div class="order-consumption-page__title">话单消费</div>
                <div class="order-consumption-page__subtitle">共 {{ total }} 条记录</div>
            </div>
        </div>

        <!-- 内容卡片 -->
        <div class="order-consumption-content-card">
            <!-- 报表数据区域 -->
            <div class="order-consumption-section order-consumption-section--report">
                <div class="order-consumption-section__title">
                    <span>消费明细</span>
                    <div class="active-filter-bar" v-if="activeFilterTags.length">
                        <el-tag
                            v-for="item in activeFilterTags"
                            :key="item.key"
                            closable
                            size="mini"
                            type="info"
                            @close="removeFilterTag(item.key)"
                        >
                            {{ item.label }}：{{ item.value }}
                        </el-tag>
                        <el-button type="text" size="mini" @click="reset()">清空筛选</el-button>
                    </div>
                    <button class="order-consumption-filter-trigger" @click="openFilterDrawer">
                        <i class="el-icon-s-operation"></i> 筛选
                        <span v-if="activeFilterTags.length" class="filter-badge">{{ activeFilterTags.length }}</span>
                    </button>
                </div>

                <!-- 表格区域 -->
                <div class="order-consumption-table-wrap tableAuto">
                    <div class="tableAutoMain">
                        <el-table
                            ref="Table1"
                            :data="KhList"
                            style="width: 100%"
                            height="calc(100% - 0.1rem)"
                            v-if="KhList.length > 0"
                        >
                            <el-table-column align="left" show-overflow-tooltip label="用户" width="140" fixed>
                                <template slot-scope="scope">
                                    <div class="order-consumption-member-cell">
                                        <span class="order-consumption-avatar-icon" :style="{ background: getAvatarColor(scope.row.UserName) }">
                                            {{ scope.row.UserName ? scope.row.UserName.charAt(0).toUpperCase() : '?' }}
                                        </span>
                                        <div class="order-consumption-member-info">
                                            <div class="order-consumption-member-name">{{ scope.row.UserName }}</div>
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>

                            <el-table-column align="center" show-overflow-tooltip label="通话秒数" prop="Second" width="110">
                                <template slot-scope="scope">{{ scope.row.Second }}</template>
                            </el-table-column>

                            <el-table-column align="center" show-overflow-tooltip label="扣费/元" width="110">
                                <template slot-scope="scope">{{ scope.row.ExpenseMoney }}</template>
                            </el-table-column>

                            <el-table-column align="center" show-overflow-tooltip label="套餐类型" width="100">
                                <template slot-scope="scope">
                                    <span class="order-consumption-status-badge" :class="scope.row.IsRentCost ? 'order-consumption-status-badge--green' : 'order-consumption-status-badge--orange'">
                                        {{ scope.row.IsRentCost ? '套餐内' : '套餐外' }}
                                    </span>
                                </template>
                            </el-table-column>

                            <el-table-column align="center" show-overflow-tooltip label="通话开始时间" min-width="170">
                                <template slot-scope="scope">{{ scope.row.CallStarttime | formaDate('yyyy-MM-dd hh:mm:ss') }}</template>
                            </el-table-column>

                            <el-table-column align="center" show-overflow-tooltip label="通话结束时间" min-width="170">
                                <template slot-scope="scope">{{ scope.row.CallEndtime | formaDate('yyyy-MM-dd hh:mm:ss') }}</template>
                            </el-table-column>
                        </el-table>
                        <div v-else class="order-consumption-empty">
                            <i class="el-icon-document"></i>
                            <p>暂无消费数据</p>
                        </div>
                    </div>
                </div>

                <!-- 分页 -->
                <div class="order-consumption-pagination">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :current-page.sync="listQuery.PageIndex"
                        :page-size="listQuery.PageSize"
                        :page-sizes="[10, 20, 50]"
                        :total="total"
                    >
                    </el-pagination>
                </div>
            </div>

        <!-- 筛选抽屉 -->
        <el-drawer
            title="筛选条件"
            :visible.sync="filterDrawerVisible"
            direction="rtl"
            size="45%"
            custom-class="order-consumption-filter-drawer"
            :wrapper-closable="false"
            :modal="false"
            :append-to-body="false"
            :destroy-on-close="true"
        >
            <div class="drawer-filter-body">
                <section class="drawer-filter-section">
                    <h4>通话日期</h4>
                    <div class="drawer-filter-item">
                        <el-date-picker
                            v-model="searchDate"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :picker-options="pickerOptions"
                            style="width:100%"
                        >
                        </el-date-picker>
                    </div>
                </section>

                <section class="drawer-filter-section">
                    <h4>用户</h4>
                    <div class="drawer-filter-item">
                        <el-select filterable v-model="listQuery.UserinfoId" size="small" placeholder="全部" style="width:100%">
                            <el-option v-for="item in childUserList" :key="item.Id" :label="item.NickName" :value="item.Id"></el-option>
                        </el-select>
                    </div>
                </section>

                <section class="drawer-filter-section">
                    <h4>套餐类型</h4>
                    <div class="drawer-filter-item">
                        <el-select filterable v-model="listQuery.IsRentCost" size="small" placeholder="全部" style="width:100%">
                            <el-option v-for="item in packageOption" :key="item.value" :label="item.name" :value="item.value"></el-option>
                        </el-select>
                    </div>
                </section>
            </div>
            <div class="drawer-filter-footer">
                <el-button size="mini" @click="reset()">重置</el-button>
                <el-button type="primary" size="mini" @click="applyDrawerFilter">应用筛选</el-button>
            </div>
        </el-drawer>
    </div>
</div>
</template>

<script>
import { decryptData } from '@/utils/aes.js';
import { GetCallExpensePageList } from '@/api/Call';
import { GetChildUserList } from '@/api/UserInfo';

export default {
    components: {},
    data() {
        return {
            childUserList: [],
            packageOption: [
                { name: '全部', value: -1 },
                { name: '套餐内', value: 1 },
                { name: '套餐外', value: 0 }
            ],
            searchDate: null,
            listQuery: {},
            KhList: [],
            total: 0,
            listLoading: true,
            filterDrawerVisible: false,
            pickerOneDate: '',
            pickerOptions: {
                onPick: ({ maxDate, minDate }) => {
                    this.pickerOneDate = minDate.getTime();
                    if (maxDate) {
                        this.pickerOneDate = '';
                    }
                },
                disabledDate: (time) => {
                    if (this.pickerOneDate) {
                        const day = 30 * 24 * 3600 * 1000;
                        let maxTime = this.pickerOneDate + day;
                        let minTime = this.pickerOneDate - day;
                        return time.getTime() > maxTime || time.getTime() < minTime;
                    }
                }
            },
            decryptedData: {}
        };
    },
    created() {
        let rootDate = new Date().toLocaleDateString();
        let StartTime = this.$options.filters['formaDate'](new Date(rootDate + ' 00:00:00'), 'yyyy-MM-dd hh:mm:ss');
        let EndTime = this.$options.filters['formaDate'](new Date(rootDate + ' 23:59:59'), 'yyyy-MM-dd hh:mm:ss');
        this.searchDate = [StartTime, EndTime];
        this.listQuery = {
            PageIndex: 1,
            PageSize: 10,
            IsRentCost: -1
        };
        this.getHeadUrl();
        this.getOption();
        this.getList();
    },
    computed: {
        activeFilterTags() {
            var tags = [];
            var self = this;
            var addTag = function(key, label, value) {
                if (value !== undefined && value !== null && value !== '' && value !== -1) {
                    tags.push({ key: key, label: label, value: value });
                }
            };
            addTag('UserinfoId', '用户', self.getOptionLabel(self.childUserList, self.listQuery.UserinfoId, 'NickName'));
            addTag('IsRentCost', '套餐类型', self.getOptionLabel(self.packageOption, self.listQuery.IsRentCost, 'name', 'value'));
            if (self.searchDate && self.searchDate.length === 2) {
                var dateStr = self.searchDate[0].slice(0, 10) + ' 至 ' + self.searchDate[1].slice(0, 10);
                addTag('searchDate', '通话日期', dateStr);
            }
            return tags;
        }
    },
    methods: {
        getAvatarColor(name) {
            const colors = ['#007aff', '#34c759', '#ff9500', '#ff3b30', '#af52de', '#5856d6', '#ff2d55', '#64d2ff'];
            let hash = 0;
            for (let i = 0; i < (name || '').length; i++) {
                hash = name.charCodeAt(i) + ((hash << 5) - hash);
            }
            return colors[Math.abs(hash) % colors.length];
        },
        reset() {
            this.listQuery = {
                PageIndex: 1,
                PageSize: 10,
                IsRentCost: -1
            };
            let rootDate = new Date().toLocaleDateString();
            let StartTime = this.$options.filters['formaDate'](new Date(rootDate + ' 00:00:00'), 'yyyy-MM-dd hh:mm:ss');
            let EndTime = this.$options.filters['formaDate'](new Date(rootDate + ' 23:59:59'), 'yyyy-MM-dd hh:mm:ss');
            this.searchDate = [StartTime, EndTime];
            this.filterDrawerVisible = false;
            this.getList();
        },
        getOption() {
            GetChildUserList({})
                .then((res) => {
                    this.childUserList = res.data.Data;
                })
                .catch(() => {});
        },
        getHeadUrl() {
            let encryptionKey = localStorage.getItem('encryptionKey');
            let userInfo = localStorage.getItem('userInfo');
            this.decryptedData = JSON.parse(decryptData(userInfo, encryptionKey));
        },
        handleSizeChange(val) {
            this.listQuery.PageIndex = 1;
            this.listQuery['PageSize'] = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.listQuery.PageIndex = val;
            this.getList();
        },
        getList() {
            this.listLoading = true;
            if (this.searchDate) {
                this.listQuery.StartTime = this.searchDate[0];
                this.listQuery.EndTime = this.searchDate[1];
            } else {
                this.$alert('请选择通话时间', '', {
                    confirmButtonText: '确定',
                    callback: () => {}
                });
                return;
            }
            GetCallExpensePageList(this.listQuery)
                .then((res) => {
                    this.listLoading = false;
                    this.KhList = res.data.Data;
                    this.total = res.data.Total;
                })
                .catch(() => {
                    this.listLoading = false;
                });
        },
        openFilterDrawer() {
            this.filterDrawerVisible = true;
        },
        applyDrawerFilter() {
            this.listQuery.PageIndex = 1;
            this.filterDrawerVisible = false;
            this.getList();
        },
        removeFilterTag(key) {
            if (key === 'searchDate') {
                this.searchDate = null;
            } else {
                this.$delete(this.listQuery, key);
            }
            this.listQuery.PageIndex = 1;
            this.getList();
        },
        getOptionLabel(options, value, labelKey, valueKey) {
            if (value === undefined || value === null || value === '') return '';
            if (!Array.isArray(options)) return '';
            var key = valueKey || 'Id';
            var option = options.find(function(item) { return item[key] == value; });
            return option ? option[labelKey] : '';
        }
    }
};
</script>

<style lang="scss" scoped>
/* ===========================
   话单消费页面 - Apple Mac 风格
   =========================== */
.order-consumption-page {
    background: #f5f5f7;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 16px;
}

/* 页面头部 */
.order-consumption-page__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px 8px;
    flex-shrink: 0;
    background: transparent;
}

.order-consumption-page__header-left {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    gap: 8px;
}

.order-consumption-page__title {
    font-size: 20px;
    font-weight: 700;
    color: #1d1d1f;
    line-height: 1.2;
}

.order-consumption-page__subtitle {
    font-size: 11px;
    color: #86868b;
}

/* 白色大卡片 */
.order-consumption-content-card {
    flex: 1;
    min-height: 0;
    margin: 8px 20px 16px;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

/* 通用区域 */
.order-consumption-section {
    padding: 0;
}

.order-consumption-section--report {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
}

.order-consumption-section__title {
    font-size: 14px;
    font-weight: 600;
    color: #1d1d1f;
    padding: 8px 16px 4px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

/* 筛选触发按钮 */
.order-consumption-filter-trigger {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px 10px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 500;
    color: #007aff;
    background: rgba(0, 122, 255, 0.08);
    border: 1px solid rgba(0, 122, 255, 0.15);
    cursor: pointer;
    transition: background 0.15s;
    white-space: nowrap;
    line-height: 1;
    flex-shrink: 0;

    &:hover {
        background: rgba(0, 122, 255, 0.15);
    }
}

.filter-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 16px;
    height: 16px;
    padding: 0 4px;
    border-radius: 999px;
    background: #007aff;
    color: #fff;
    font-size: 10px;
    line-height: 16px;
}

/* 已选筛选标签 */
.active-filter-bar {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    flex: 1;
    margin: 0 8px;
    overflow: hidden;
    color: #64748b;
    font-size: 12px;

    ::v-deep .el-tag {
        border-color: #dbe7ff;
        background: #f8fbff;
        color: #334155;
        flex-shrink: 0;
    }

    .el-button {
        flex-shrink: 0;
    }
}

/* 表格区域 */
.order-consumption-table-wrap {
    flex: 1;
    min-height: 0;
    overflow: hidden;
    padding: 0;
    display: flex;
    flex-direction: column;
    background: #f5f5f7;
}

::v-deep .order-consumption-table-wrap .el-table {
    background: transparent;

    &::before {
        display: none;
    }

    /* 表头 */
    .el-table__header-wrapper {
        background: #f5f5f7 !important;
    }

    .el-table__header tr {
        background: transparent !important;
    }

    thead th {
        background: #f5f5f7 !important;
        color: #86868b;
        font-size: 10px;
        font-weight: 600;
        border: none !important;
        padding: 4px 0;
    }

    thead th .cell {
        background: transparent !important;
        color: #86868b;
        font-size: 10px;
        font-weight: 600;
        border: none !important;
    }

    /* 固定列 */
    .el-table__fixed {
        thead th {
            background: #f5f5f7 !important;
        }

        &::before {
            display: none !important;
        }

        tbody td {
            background: #fff !important;
            border-bottom: 8px solid #f5f5f7 !important;
            box-shadow: none !important;
        }
    }

    .el-table__fixed-right-patch {
        background: #f5f5f7 !important;
    }

    /* 数据行卡片化 */
    .el-table__body {
        border-collapse: collapse;
        width: 100% !important;
    }

    tbody tr {
        background: transparent !important;
    }

    tbody td {
        background: #fff !important;
        font-size: 13px;
        color: #1d1d1f;
        padding: 8px 0 !important;
        border-bottom: 8px solid #f5f5f7 !important;
        border-top: none !important;
        border-right: none !important;
        transition: background 0.15s;
    }

    tbody td .cell {
        font-size: 13px;
    }

    tbody tr td:first-child {
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
    }

    tbody tr td:last-child {
        border-top-right-radius: 12px;
        border-bottom-right-radius: 12px;
    }

    tr:hover td {
        background: #fff !important;
    }
}

/* 成员列 */
.order-consumption-member-cell {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding-left: 8px;
}

.order-consumption-avatar-icon {
    width: 28px;
    height: 28px;
    border-radius: 8px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 700;
    color: #fff;
    flex-shrink: 0;
    line-height: 1;
}

.order-consumption-member-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    text-align: left;
}

.order-consumption-member-name {
    font-size: 12px;
    font-weight: 600;
    color: #1d1d1f;
    line-height: 1.2;
}

/* 状态徽章 */
.order-consumption-status-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 1px 6px;
    border-radius: 6px;
    font-size: 10px;
    font-weight: 500;
    color: #fff;
    line-height: 1.4;
    white-space: nowrap;

    &--green {
        background: #34c759;
    }

    &--orange {
        background: #ff9500;
    }
}

/* 空状态 */
.order-consumption-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 0;
    color: #86868b;

    i {
        font-size: 48px;
        margin-bottom: 12px;
        opacity: 0.4;
    }

    p {
        font-size: 13px;
    }
}

/* 分页器 */
.order-consumption-pagination {
    padding: 14px 20px;
    border-top: 0.5px solid rgba(0, 0, 0, 0.06);
    display: flex;
    justify-content: flex-end;
    flex-shrink: 0;
}

/* 筛选抽屉 */
::v-deep .order-consumption-filter-drawer {
    width: 45% !important;
    .el-drawer__header {
        margin-bottom: 0;
        padding: 18px 20px 14px;
        border-bottom: 1px solid #edf2fb;
        color: #0f172a;
        font-weight: 700;
    }
    .el-drawer__body {
        display: flex;
        flex-direction: column;
        height: calc(100% - 54px);
    }
}
</style>

<style>
/* 筛选抽屉内容（全局样式） */
.drawer-filter-body {
    flex: 1;
    overflow-y: auto;
    padding: 16px 20px 88px;
    box-sizing: border-box;
}

.drawer-filter-section {
    padding-bottom: 18px;
    margin-bottom: 18px;
    border-bottom: 1px solid #edf2fb;

    h4 {
        margin: 0 0 12px;
        font-size: 14px;
        line-height: 20px;
        color: #0f172a;
    }
}

.drawer-filter-item {
    margin-bottom: 12px;
}

.drawer-filter-item > span {
    display: block;
    margin-bottom: 6px;
    color: #475569;
    font-size: 12px;
    line-height: 18px;
    font-weight: 600;
}

.drawer-filter-item ::v-deep .el-input,
.drawer-filter-item ::v-deep .el-select,
.drawer-filter-item ::v-deep .el-cascader,
.drawer-filter-item ::v-deep .el-date-editor {
    width: 100% !important;
}

.drawer-filter-footer {
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    padding: 12px 20px;
    border-top: 1px solid #edf2fb;
    background: #fff;
}
</style>
